// src/config/navConfig.js
const NAV_ITEMS = [
  { name: "Home", path: "/" },
  {
    name: "Bible Tools",
    children: [
      { name: "Reading Calendar", path: "/calendar" },
      { name: "Reading Tracker", path: "/dashboard" },
    ],
  },
  {
    name: "Men's Conferences",
    children: [
      { name: "DEPLOY Conference", path: "/deploy-conference" },
      { name: "2025 Conference Videos", path: "/mens-conference-2025/videos" },
    ],
  },
  {
    name: "Ministry Content",
    children: [
      { name: "Crucible Men", path: "/cmdashboard" },
      { name: "The Smart Dad Plan", path: "/smartdadplan" },
    ],
  },
];
export default NAV_ITEMS;
